import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CookieConsentService } from 'src/app/services/cookie-consent.service';

@Component({
  selector: 'app-cookie-consent-modal',
  templateUrl: './cookie-consent-modal.component.html',
  styleUrls: ['./cookie-consent-modal.component.scss'],
})
export class CookieConsentModalComponent {
  constructor(
    private modalController: ModalController,
    private cookieConsentService: CookieConsentService
  ) {}

  public giveConsent(): void {
    this.cookieConsentService.allowCookies();
    this.modalController.dismiss();
  }

  public denyConsent(): void {
    this.cookieConsentService.denyCookies();
    this.modalController.dismiss();
  }
}
